<template>
  <div>
    <ErrorPage v-if="error404occured" />
    <div v-else>
      <div v-if="providerInfoLoading">
        <div class="container my-4 pl-0">
          <div aria-label="breadcrumb">
            <ol class="breadcrumb py-0 my-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'home', params: { lang: $route.params.lang }}">{{ $t('CC01-03-08') }}</router-link>
              </li>
              <li class="breadcrumb-item my-0 py-0">
                <router-link :to="{ name: 'our-providers', params: { industry: 'all', lang: $route.params.lang }}">{{ $t('CC01-02-06c') }}</router-link>
              </li>
              <li class="breadcrumb-item my-0 py-0"><SkeletonUI type="span" class="skeleton-route" /></li>
              <li class="breadcrumb-item py-0 my-0 active" aria-current="page"><SkeletonUI type="span" class="skeleton-route" /></li>
            </ol>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-show="provider_info[0]" class="container my-4 pl-0">
          <div aria-label="breadcrumb">
            <ol class="breadcrumb py-0 my-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'home', params: { lang: $route.params.lang }}">{{ $t('CC01-03-08') }}</router-link>
              </li>
              <li class="breadcrumb-item my-0 py-0">
                <router-link v-if="getEditableInfo('enabled_function', 'provider_list', false)" :to="{ name: 'our-providers', params: { industry: 'all', lang: $route.params.lang }}">{{ $t('CC01-02-06c') }}</router-link>
                <a v-else class="disabled">{{ $t('CC01-02-06c') }}</a>
              </li>
              <li v-if="provider_info[0] && provider_info[0].provider_industry" class="breadcrumb-item my-0 py-0">
                <router-link v-if="getEditableInfo('enabled_function', 'provider_list', false)" :to="{ name: 'our-providers', params: { industry: getIndustryFormattedName(provider_info[0].provider_industry) } }">
                  {{ provider_info[0] && getIndustryName(provider_info[0].provider_industry) }}
                </router-link>
                <a v-else class="disabled">{{ provider_info[0] && getIndustryName(provider_info[0].provider_industry) }}</a>
              </li>
              <li class="breadcrumb-item my-0 py-0 active" aria-current="page"><a class="disabled">{{ provider_info[0] && provider_info[0].display_name }}</a></li>
            </ol>
          </div>
        </div>
      </div>

      <div class="bg-img-hero-center cover-image-container">
        <template v-if="providerInfoLoading">
          <SkeletonUI type="img cover-image" class="container cover-image" />
        </template>
        <template v-else>
          <img v-img="{ type:'xl', class: 'cover-image' }" class="w-100 cover-image" :src="((provider_info[0] && provider_info[0].theme_data && provider_info[0].theme_data.landing && provider_info[0].theme_data.landing.hero_section && provider_info[0].theme_data.landing.hero_section.cover_photo_url) ? provider_info[0].theme_data.landing.hero_section.cover_photo_url : !providerInfoLoading ? require('@/assets/img/provider-default/default-cover.jpg') : '')">
        </template>
      </div>

      <div class="gradient-y-gray">
        <div v-if="providerInfoLoading">
          <div class="container space-1">
            <div class="media mt-1">
              <div class="avatar mr-5">
                <SkeletonUI type="img" class="avatar-img skeleton-image" />
              </div>
              <div class="media-body">
                <div class="d-flex align-items-center">
                  <SkeletonUI type="h2" class="skeleton-h2" />
                </div>
                <SkeletonUI type="p" :lines="2" class="mb-2" />
                <SkeletonUI type="span" class="skeleton-span" />
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="container space-1">
            <div class="media mt-1">
              <div class="avatar mr-5">
                <img v-img="{ type:'medium' }" class="avatar-img" :src="(provider_info[0] && provider_info[0].theme_data && provider_info[0].theme_data.profile_picture_url) ? provider_info[0] && provider_info[0].theme_data.profile_picture_url : require('@/assets/developer-icon/500x500-01.jpg')" alt="Image Description">
              </div>
              <div class="media-body">
                <div class="d-flex align-items-center">
                  <h1 class="h2">{{ provider_info[0] && provider_info[0].display_name }}</h1>
                </div>
                <p class="mb-2"> {{ provider_info[0] && provider_info[0].provider_short_description }}</p>
                <template v-if="provider_info[0] && (provider_info[0].company_business_email || provider_info[0].company_technical_email || provider_info[0].contact_phone_country || provider_info[0].contact_phone_number || provider_info[0].provider_website)">
                  <span v-b-modal.more-provider-info-dialog class="link font-weight-normal">{{ $t('M-M05a-06b-01') }}</span>
                  <b-modal id="more-provider-info-dialog" centered hide-footer>
                    <template slot="modal-header-close">
                      <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" aria-label="Close">
                        <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
                      </button>
                    </template>
                    <h3>{{ $t('CC11-02-04') }} {{ provider_info[0] && provider_info[0].display_name }}</h3>
                    <ul class="contact-info-list mb-0">
                      <li v-if="provider_info[0] && provider_info[0].company_business_email && provider_info[0].company_business_email !== ''" class="grid">
                        <i class="fas fa-envelope mr-2 pr-1 align-center" />
                        <div>
                          <div>{{ $t('CC11-02-05b') }}</div>
                          <a :href="`mailto:${provider_info[0].company_business_email}`">{{ provider_info[0].company_business_email }}</a>
                        </div>
                      </li>
                      <li v-if="provider_info[0] && provider_info[0].company_technical_email && provider_info[0].company_technical_email !== ''" class="grid">
                        <i class="fas fa-envelope mr-2 pr-1 align-center" />
                        <div>
                          <div>{{ $t('CC11-02-05c') }}</div>
                          <a :href="`mailto:${provider_info[0].company_technical_email}`">{{ provider_info[0].company_technical_email }}</a>
                        </div>
                      </li>
                      <li v-if="provider_info[0] && provider_info[0].contact_phone_country && provider_info[0].contact_phone_number !== ''">
                        <i class="fas fa-phone-alt mr-2 pr-1" />
                        <a :href="`tel:${provider_info[0].contact_phone_country}${provider_info[0].contact_phone_number}`">{{ `${provider_info[0].contact_phone_country} ${provider_info[0].contact_phone_number}` }}</a>
                      </li>
                      <li v-if="provider_info[0] && provider_info[0].provider_website && provider_info[0].provider_website !== ''">
                        <i class="fas fa-globe mr-2 pr-1" />
                        <a
                          :href="!provider_info[0].provider_website.startsWith('http') ? `https://${provider_info[0].provider_website}` : provider_info[0].provider_website"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {{ !provider_info[0].provider_website.startsWith('http') ? `https://${provider_info[0].provider_website}` : provider_info[0].provider_website }}
                        </a>
                      </li>
                    </ul>
                  </b-modal>
                </template>

              </div>
            </div>
          </div>
        </div>
        <!-- Nav -->
        <div class="container">
          <div class="js-nav-scroller hs-nav-scroller-horizontal">
            <span class="hs-nav-scroller-arrow-prev d-none">
              <a class="hs-nav-scroller-arrow-link">
                <i class="fa fa-chevron-left" />
              </a>
            </span>

            <span class="hs-nav-scroller-arrow-next d-none">
              <a class="hs-nav-scroller-arrow-link">
                <i class="fa fa-chevron-right" />
              </a>
            </span>

            <ul id="pills-tab" class="nav nav-classic tab-list" role="tablist">
              <li id="ga-CC01-03-08" class="nav-item" @click="switchTab('home')">
                <a id="home" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'home' }">
                  <div class="d-md-flex justify-content-md-center align-items-md-center">
                    {{ $t('CC01-03-08') }}
                  </div>
                </a>
              </li>
              <li id="ga-CC01-03-09" class="nav-item" @click="switchTab('api')">
                <a id="api" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'api' }">
                  <div class="d-md-flex justify-content-md-center align-items-md-center">
                    {{ $t('CC01-03-09') }}
                  </div>
                </a>
              </li>
              <li id="ga-CC01-03-10" class="nav-item" @click="switchTab('guides')">
                <a id="guides" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'guides' }">
                  <div class="d-md-flex justify-content-md-center align-items-md-center">
                    {{ $t('CC01-03-10') }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <ul id="pills-tab" class="nav nav-classic nav-justified tab-list" role="tablist">
          <li id="ga-CC01-03-08" class="nav-item" @click="switchTab('home')">
            <a id="home" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'home' }">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                {{ $t('CC01-03-08') }}
              </div>
            </a>
          </li>
          <li id="ga-CC01-03-09" class="nav-item" @click="switchTab('api')">
            <a id="api" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'api' }">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                {{ $t('CC01-03-09') }}
              </div>
            </a>
          </li>
          <li id="ga-CC01-03-10" class="nav-item" @click="switchTab('guides')">
            <a id="guides" class="marketplace-provider-tab nav-link cursor-pointer" :class="{ active: $route.params.tab_name === 'guides' }">
              <div class="d-md-flex justify-content-md-center align-items-md-center">
                {{ $t('CC01-03-10') }}
              </div>
            </a>
          </li>
        </ul> -->
      <!-- End Nav -->
      </div>
      <div>
        <SkeletonUI v-if="activeTab === '' && loading" type="empty" class="loading-tab" />
        <ProviderInfoHome v-if="activeTab === 'home'" :providerInfo="provider_info" :featuredApis="featured_api" />
        <ProviderInfoApi v-if="activeTab === 'api'" :providerInfo="provider_info" :apiGroups="api_groups" />
        <ProviderInfoGuides v-if="activeTab === 'guides'" :providerInfo="provider_info" :guides="guides" :lastUpdateDate="last_update_date" :apis="apis" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProviderInfoHome from './components/home'
import ProviderInfoApi from './components/api'
import ProviderInfoGuides from './components/guides'
import SkeletonUI from '@/components/skeleton-ui'
import { getAuthInfo, getProviderInfo, getTopFiveAPI, searchAPI } from '@/api/profile'
import { getReadme } from '@/api/readme'
import ErrorPage from '@/views/error-page/index'
import Axios from 'axios'
import { getIndustryCode, getIndustryKeyCodeByValue, getIndustryFormattedName } from '@/utils/format-util'
import getEditableInfo from '@/utils/get-editable-info'
const $ = require('jquery')

export default {
  name: 'ProviderInfo',
  components: {
    ProviderInfoHome,
    ProviderInfoApi,
    ProviderInfoGuides,
    ErrorPage,
    SkeletonUI
  },
  data() {
    return {
      activeTab: '',
      goingToTab: '',
      provider_short_id: '',
      provider_info: [],
      featured_api: [],
      api_groups: ['All'],
      apis: [],
      guides: '',
      last_update_date: '',
      theme_color: '#57ABF0',
      tabList: [
        { label: '', value: 'home', tab_name: 'Meta-M05a-tab' },
        { label: 'API Collection', value: 'api', tab_name: 'Meta-M05b-tab' },
        { label: 'API Guides', value: 'guides', tab_name: 'Meta-M05d-tab' }
      ],
      error404occured: false,
      loaded: false,
      providerInfoLoading: false
    }
  },
  computed: {
    ...mapGetters(['userProfile', 'loading', 'site_info'])
  },
  watch: {
    $route(to, from) {
      if (to.params && to.params.tab_name && to.params?.tab_name !== from.params?.tab_name) {
        this.goingToTab = to.params.tab_name
      }
    },
    async goingToTab() {
      if (this.goingToTab !== '') {
        if (this.provider_info[0] && this.provider_info[0]?.provider_type !== 'public') {
          const auth = await getAuthInfo().catch(e => {
            return {}
          })
          if ($.isEmptyObject(auth)) {
            const redirectURL = `${window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/${this.goingToTab}`
            this.$router.push({
              name: 'login-to-continue',
              params: this.$route.params,
              query: {
                redirect: encodeURIComponent(redirectURL)
              }
            })
          } else {
            this.activeTab = this.goingToTab
          }
        } else {
          this.activeTab = this.goingToTab
        }
      }
    },
    activeTab() {
      this.$router.push({
        name: 'provider-info',
        params: {
          provider_name: this.$route.params.provider_name,
          tab_name: this.activeTab
        },
        hash: this.activeTab === 'guides' ? this.$route.hash : ''
      })
      if (this.provider_info[0]) {
        // change tab title based on activeTab value
        var active = this.tabList.find(item => item.value === this.activeTab)
        document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
      }
      this.goingToTab = ''
    },
    '$i18n.locale'() {
      var active = this.tabList.find(item => item.value === this.activeTab)
      document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
    }
  },
  async created() {
    var routeParams = this.$route.params && this.$route.params.provider_name.split('-')
    this.provider_short_id = routeParams[routeParams.length - 1]
    await this.initialise()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'provider-info') {
      this.$store.dispatch('app/setShowUpgradedPortal', false)
    }
    next()
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      await this.getProvider(this.provider_short_id)
      if (this.provider_info[0]) {
        // change tab title
        var active = this.tabList.find(item => item.value === this.$route.params.tab_name)
        document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
        this.$store.dispatch('branded/setProviderInfo', {
          verification_status: this.provider_info[0].verification_status
        })
        // wait for active tab styling
        this.$nextTick(() => {
          this.$store.dispatch('app/setLoading', false)
          this.loaded = true
        })
      } else {
        this.$store.dispatch('app/setLoading', false)
        this.loaded = true
      }
    },
    async getProvider(providerShortId) {
      this.providerInfoLoading = true
      await getProviderInfo(this.userProfile.id, providerShortId)
        .then(async res => {
          const response = res['data'].map(provider => {
            return {
              ...provider,
              company_business_email: provider.business_support_email,
              company_technical_email: provider.technical_support_email,
              provider_id: provider.id,
              provider_short_id: provider.short_id,
              provider_industry: getIndustryKeyCodeByValue(provider.industry),
              provider_short_description: provider.short_description,
              provider_website: provider.website,
              provider_type: provider.accessibility
            }
          })
          this.provider_info = response
          if (this.provider_info.length === 0) {
            this.error404occured = true
            this.$store.dispatch('app/setLoading', false)
            this.loaded = true
          } else {
            if (this.provider_info[0].theme_data && this.provider_info[0].theme_data.cover_photo_url) {
              this.provider_info[0].theme_data && this.provider_info[0].theme_data.landing && this.provider_info[0].theme_data.landing.hero_section && this.provider_info[0].theme_data.landing.hero_section.cover_photo_url
                ? null
                : this.provider_info[0].theme_data['landing'] = {
                  ...this.provider_info[0].theme_data['landing'],
                  hero_section: {
                    ...(this.provider_info[0].theme_data['landing'] && this.provider_info[0].theme_data['landing']['hero_section'] ? this.provider_info[0].theme_data['landing']['hero_section'] : null),
                    cover_photo_url: this.provider_info[0].cover_photo_url
                  }
                }
            }
            this.providerInfoLoading = false
            this.$store.dispatch('app/setShowUpgradedPortal', (this.provider_info[0]?.theme_code.toUpperCase() === 'VIP' || this.provider_info[0]?.theme_code.toUpperCase() === 'VVIP') && this.getEditableInfo('enabled_function', 'branded_mode', false))
            // for Home page
            await this.getTopFiveAPIInfo()
            // for API Collection page
            if (this.provider_info[0].api_groups) {
              this.api_groups = this.api_groups.concat(this.provider_info[0].api_groups.sort())
            }
            // for Guides page
            if (this.provider_info[0].guides && this.provider_info[0].guides.split('.').pop() === 'md') {
              this.last_update_date = this.provider_info[0] && this.provider_info[0]?.last_edit
              await this.getReadme()
            }
            await this.getAPIListInfo()
            this.initialiseTab()
          }
        })
        .catch(error => {
          console.log('getProviderInfo error', error)
          this.error404occured = true
          this.providerInfoLoading = false
          this.$store.dispatch('app/setLoading', false)
          this.loaded = true
        })
    },
    async getTopFiveAPIInfo() {
      await getTopFiveAPI(this.userProfile.id, this.provider_short_id)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.featured_api = response
        })
        .catch(error => {
          console.log('getTopFiveAPI error', error)
        })
    },
    async getReadme() {
      await getReadme(this.provider_info[0].guides)
        .then(res => {
          this.guides = res['data']
        })
        .catch(error => {
          console.log('getProviderInfo error', error)
        })
    },
    async getAPIListInfo() {
      const axiosSource = Axios.CancelToken.source()
      var filter = { providerShortId: this.provider_short_id }
      await searchAPI(axiosSource.token, this.userProfile.id, 100, 0, filter)
        .then(res => {
          const response = res['data'].map(api => {
            return {
              ...api,
              api_id: api.id,
              api_short_id: api.short_id,
              api_name: api.name,
              api_type: api.accessibility,
              api_description: api.short_description,
              api_category: api.category,
              api_no_of_calls: api.request_count,
              api_errors_percentage: api.success_rate,
              api_latency: api.average_latency,
              api_provider_group: api.groups,
              display_name: api.provider_display_name
            }
          })
          this.apis = response
        })
        .catch(error => {
          console.log('getAPIList error', error)
        })
    },
    initialiseTab() {
      var active = this.tabList.find(item => item.value === this.$route.params.tab_name)
      if (this.$route.params.tab_name && active) {
        this.activeTab = this.$route.params.tab_name
        document.title = this.$t(active.tab_name, { provider_name: this.provider_info[0].display_name, site_name: this.site_info[this.$i18n.locale].name })
      } else {
        this.activeTab = 'home'
      }
    },
    switchTab(tab) {
      this.goingToTab = tab
    },
    getIndustryFormattedName(industry) {
      return getIndustryFormattedName(industry)
    },
    getIndustryName(industry) {
      return this.$t(getIndustryCode(industry))
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale : '')
    }
  }
}
</script>

<style lang="scss" scoped>
.marketplace-provider-tab.active {
  border-bottom-color: #57ABF0;
  color: #57ABF0;
}
.disabled {
  pointer-events:none;
  color: #D3D3D3;
}
.avatar {
  height: 100px;
  width: 100px;
  box-shadow: 0 12px 15px 0 rgba(140,152,164,0.1);
}
.avatar-img {
  width: 100%;
  height: 100%;
}
.nav-item {
  margin-bottom: 2px;
  .nav-link {
    border-radius: 0px !important;
  }
}
.cover-image-container {
  max-width: 1680px;
  text-align: center;
  margin: auto;
  padding: 0;
  display: block;
}
.cover-image {
  background-size: cover;
}
.contact-info-list {
  list-style-type: none;
  padding: 0;
  li {
    padding-top: 12px;
    &:not(:last-child) {
      padding-bottom: 0px;
    }
    i {
      margin-top: -24px;
    }
  }
}
@media (max-width: 400px) {
  .nav-link.cursor-pointer {
    padding: 4px;
  }
}
.href {
  opacity: 0.7;
}
.href:hover {
  opacity: 1;
}
@media (max-width: 991.98px) {
  .tab-list {
    max-width: 100%;
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
  }
}
.grid {
  display: flex;
  grid-template-columns: auto 1fr;
}
.align-center {
  align-self: center;
}
.hs-nav-scroller-horizontal {
  position: relative;
}
.hs-nav-scroller-horizontal .nav {
  overflow-x: auto;
  overflow-y: hidden;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  white-space: nowrap;
  scroll-behavior: smooth;
}
.hs-nav-scroller-horizontal .nav .nav-item {
  white-space: nowrap;
}
.hs-nav-scroller-horizontal .nav .nav-link {
  white-space: nowrap;
}
.hs-nav-scroller-horizontal .nav::-webkit-scrollbar {
  display: none;
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next, .hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev {
  position: absolute;
  height: 100%;
  z-index: 1;
  font-size: 1.5rem;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link {
  width: 3.125rem;
  color: #677788;
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link:hover {
  color: #57abf0;
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev {
  left: 0;
  margin-left: -.125rem;
  background-image: linear-gradient(to right, #fff 50%, rgba(255, 255, 255, 0) 100%);
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev .hs-nav-scroller-arrow-link {
  padding: .5rem 0;
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next {
  right: 0;
  margin-right: -.125rem;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0, #fff 50%);
}
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next .hs-nav-scroller-arrow-link {
  padding: .5rem 0;
  text-align: right;
}

.hs-nav-scroller-horizontal .nav-tabs .nav-link.active {
  border: 0;
  font-weight: 600;
  background-color: transparent;
}

.hs-nav-scroller-horizontal .nav-tabs .nav-link {
  border: 0;
  padding: 0.75rem 1rem;
  border-radius: 0;
}

.hs-nav-scroller-horizontal .nav-tabs .nav-link.active {
  border-bottom: #57abf0 3px solid !important;
}
.skeleton-h2 {
  width: 70%;
}
.skeleton-span {
  width: 75px;
}
</style>
